import { Button, Flex, Spacing } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'
import { EInvoicingGenericStep } from '../EInvoicingStep/elements/EInvoicingGenericStep'
import { EInvoicingProgressBar } from '../EInvoicingStep/elements/EInvoicingProgressBar'
import { EInvoicingStepContainer } from '../EInvoicingStep/elements/EInvoicingStepContainer'

export const EInvoicingFilesSuccessStep = () => {
  const { t } = useTranslation()

  const { navigateToEInvoices, goToNextStep } = useEInvoicingSetup()

  const handleContinueToNextStep = useCallback(() => {
    goToNextStep()
  }, [goToNextStep])

  return (
    <EInvoicingStepContainer
      headerContent={<EInvoicingProgressBar title={t('e_invoice.kyc.step.signature.progress.title')} />}
    >
      <EInvoicingGenericStep
        title={t('e_invoice.kyc.step.files_success.title')}
        bannerText={t('e_invoice.kyc.step.files_success.subtitle')}
        bannerType="info"
      >
        <Flex flexDirection="column" gap={Spacing.S12}>
          <Button variant="filled" onClick={handleContinueToNextStep} fullWidth>
            {t('e_invoice.kyc.step.files_success.cta.primary')}
          </Button>
          <Button variant="text" fullWidth onClick={navigateToEInvoices}>
            {t('e_invoice.kyc.step.cancel')}
          </Button>
        </Flex>
      </EInvoicingGenericStep>
    </EInvoicingStepContainer>
  )
}
